import React from 'react';
import Breadcrumbs from '../components/Breadcrumbs';
import '../styles/Breadcrumbs.css';
import '../styles/ComingSoon.css';

const ComingSoonPage = () => {
  return (
    <>
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Coming Soon' }]} />
      <main className="coming-page">
        <section className="coming-section">
          <h1>Coming Soon</h1>
        </section>
      </main>
    </>
  );
};

export default ComingSoonPage;